import React from 'react';

export default function HeaderSeparator () {
	return (
		<div className='headerSeparator' />
	);
}
